import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "closet-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "신체 정보"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "내 치수를 기록해 옷 사이즈의 기준으로 삼고, 한국인 평균과 비교해 보세요")
], -1)
const _hoisted_3 = { class: "body-layout" }
const _hoisted_4 = { class: "body-form-section" }
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "신체 정보", -1)
const _hoisted_8 = { class: "form-title-right" }
const _hoisted_9 = { class: "unit-toggle" }
const _hoisted_10 = { class: "toggle-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "공개", -1)
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-group sm" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "성별", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "선택", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "MALE" }, "남성", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "FEMALE" }, "여성", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "form-group sm" }
const _hoisted_20 = ["data-tooltip"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group sm" }
const _hoisted_23 = ["data-tooltip"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = { class: "form-group sm" }
const _hoisted_27 = ["data-tooltip"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-group sm" }
const _hoisted_30 = ["data-tooltip"]
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "form-group sm" }
const _hoisted_33 = ["data-tooltip"]
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = { class: "form-group sm" }
const _hoisted_37 = ["data-tooltip"]
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "form-group sm" }
const _hoisted_40 = ["data-tooltip"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "form-group sm" }
const _hoisted_43 = ["data-tooltip"]
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "form-row" }
const _hoisted_46 = { class: "form-group sm" }
const _hoisted_47 = ["data-tooltip"]
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "form-group sm" }
const _hoisted_50 = ["data-tooltip"]
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "form-group sm" }
const _hoisted_53 = ["data-tooltip"]
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "form-row" }
const _hoisted_56 = { class: "form-group sm" }
const _hoisted_57 = ["data-tooltip"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "form-actions" }
const _hoisted_60 = { class: "body-svg-section" }
const _hoisted_61 = { class: "svg-card" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "svg-title" }, "내 신체 치수", -1)
const _hoisted_63 = { class: "svg-container" }
const _hoisted_64 = {
  viewBox: "0 0 360 470",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("path", {
  d: "\r\n                M 141,68\r\n                A 24,24 0 1 1 159,68\r\n                L 159,78\r\n                L 200,88\r\n                L 270,158\r\n                Q 278,168 252,176\r\n                L 182,106\r\n                L 182,222\r\n                L 198,390\r\n                L 216,390\r\n                L 216,406\r\n                L 172,406\r\n                L 172,390\r\n                L 162,234\r\n                Q 150,244 138,234\r\n                L 128,390\r\n                L 128,406\r\n                L 84,406\r\n                L 84,390\r\n                L 102,390\r\n                L 118,222\r\n                L 118,106\r\n                L 48,176\r\n                Q 22,168 30,158\r\n                L 100,88\r\n                L 141,78\r\n                Z\r\n              ",
  fill: "#e8edf3",
  stroke: "#555",
  "stroke-width": "2.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<line x1=\"306\" y1=\"22\" x2=\"306\" y2=\"406\" stroke=\"#888\" stroke-width=\"0.8\" stroke-dasharray=\"4,2\"></line><line x1=\"302\" y1=\"22\" x2=\"310\" y2=\"22\" stroke=\"#888\" stroke-width=\"1\"></line><line x1=\"302\" y1=\"406\" x2=\"310\" y2=\"406\" stroke=\"#888\" stroke-width=\"1\"></line><line x1=\"174\" y1=\"22\" x2=\"306\" y2=\"22\" stroke=\"#888\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><rect x=\"282\" y=\"200\" width=\"66\" height=\"24\" rx=\"4\" fill=\"#fff\" stroke=\"#ddd\" stroke-width=\"0.5\"></rect>", 5)
const _hoisted_72 = {
  x: "315",
  y: "212",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_73 = {
  key: 0,
  x: "315",
  y: "221",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_74 = ["fill"]
const _hoisted_75 = { key: 1 }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("line", {
  x1: "100",
  y1: "80",
  x2: "200",
  y2: "80",
  stroke: "#e74c3c",
  "stroke-width": "0.8",
  "stroke-dasharray": "4,2"
}, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("line", {
  x1: "100",
  y1: "76",
  x2: "100",
  y2: "84",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("line", {
  x1: "200",
  y1: "76",
  x2: "200",
  y2: "84",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("rect", {
  x: "108",
  y: "60",
  width: "84",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#f0c0c0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_80 = {
  x: "150",
  y: "72",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_81 = {
  key: 0,
  x: "150",
  y: "81",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_82 = ["fill"]
const _hoisted_83 = { key: 2 }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("line", {
  x1: "46",
  y1: "130",
  x2: "118",
  y2: "130",
  stroke: "#e74c3c",
  "stroke-width": "0.8",
  "stroke-dasharray": "4,2"
}, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("line", {
  x1: "118",
  y1: "126",
  x2: "118",
  y2: "134",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("line", {
  x1: "46",
  y1: "126",
  x2: "46",
  y2: "134",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "116",
  width: "90",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#f0c0c0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_88 = {
  x: "47",
  y: "128",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_89 = {
  key: 0,
  x: "47",
  y: "137",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_90 = ["fill"]
const _hoisted_91 = { key: 3 }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("line", {
  x1: "46",
  y1: "165",
  x2: "118",
  y2: "165",
  stroke: "#e74c3c",
  "stroke-width": "0.8",
  "stroke-dasharray": "4,2"
}, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("line", {
  x1: "118",
  y1: "161",
  x2: "118",
  y2: "169",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("line", {
  x1: "46",
  y1: "161",
  x2: "46",
  y2: "169",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "150",
  width: "90",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#f0c0c0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_96 = {
  x: "47",
  y: "162",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_97 = {
  key: 0,
  x: "47",
  y: "171",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_98 = ["fill"]
const _hoisted_99 = { key: 4 }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("line", {
  x1: "38",
  y1: "210",
  x2: "118",
  y2: "210",
  stroke: "#e74c3c",
  "stroke-width": "0.8",
  "stroke-dasharray": "4,2"
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("line", {
  x1: "118",
  y1: "206",
  x2: "118",
  y2: "214",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("line", {
  x1: "38",
  y1: "206",
  x2: "38",
  y2: "214",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "196",
  width: "90",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#f0c0c0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_104 = {
  x: "47",
  y: "208",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_105 = {
  key: 0,
  x: "47",
  y: "217",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_106 = ["fill"]
const _hoisted_107 = { key: 5 }
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<line x1=\"258\" y1=\"88\" x2=\"258\" y2=\"158\" stroke=\"#3498db\" stroke-width=\"0.8\" stroke-dasharray=\"4,2\"></line><line x1=\"254\" y1=\"88\" x2=\"262\" y2=\"88\" stroke=\"#3498db\" stroke-width=\"1\"></line><line x1=\"254\" y1=\"158\" x2=\"262\" y2=\"158\" stroke=\"#3498db\" stroke-width=\"1\"></line><line x1=\"200\" y1=\"88\" x2=\"258\" y2=\"88\" stroke=\"#3498db\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><line x1=\"270\" y1=\"158\" x2=\"258\" y2=\"158\" stroke=\"#3498db\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><rect x=\"234\" y=\"112\" width=\"66\" height=\"24\" rx=\"3\" fill=\"#fff\" stroke=\"#c0d8f0\" stroke-width=\"0.5\"></rect>", 6)
const _hoisted_114 = {
  x: "267",
  y: "124",
  "text-anchor": "middle",
  class: "label-text label-blue"
}
const _hoisted_115 = {
  key: 0,
  x: "267",
  y: "133",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_116 = ["fill"]
const _hoisted_117 = { key: 6 }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("line", {
  x1: "32",
  y1: "310",
  x2: "108",
  y2: "310",
  stroke: "#e74c3c",
  "stroke-width": "0.8",
  "stroke-dasharray": "4,2"
}, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("line", {
  x1: "108",
  y1: "306",
  x2: "108",
  y2: "314",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("line", {
  x1: "32",
  y1: "306",
  x2: "32",
  y2: "314",
  stroke: "#e74c3c",
  "stroke-width": "1"
}, null, -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "298",
  width: "90",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#f0c0c0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_122 = {
  x: "47",
  y: "310",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_123 = {
  key: 0,
  x: "47",
  y: "319",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_124 = ["fill"]
const _hoisted_125 = { key: 7 }
const _hoisted_126 = /*#__PURE__*/_createStaticVNode("<line x1=\"228\" y1=\"234\" x2=\"228\" y2=\"390\" stroke=\"#3498db\" stroke-width=\"0.8\" stroke-dasharray=\"4,2\"></line><line x1=\"224\" y1=\"234\" x2=\"232\" y2=\"234\" stroke=\"#3498db\" stroke-width=\"1\"></line><line x1=\"224\" y1=\"390\" x2=\"232\" y2=\"390\" stroke=\"#3498db\" stroke-width=\"1\"></line><line x1=\"162\" y1=\"234\" x2=\"228\" y2=\"234\" stroke=\"#3498db\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><rect x=\"206\" y=\"304\" width=\"66\" height=\"24\" rx=\"3\" fill=\"#fff\" stroke=\"#c0d8f0\" stroke-width=\"0.5\"></rect>", 5)
const _hoisted_131 = {
  x: "239",
  y: "316",
  "text-anchor": "middle",
  class: "label-text label-blue"
}
const _hoisted_132 = {
  key: 0,
  x: "239",
  y: "325",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_133 = ["fill"]
const _hoisted_134 = { key: 8 }
const _hoisted_135 = /*#__PURE__*/_createStaticVNode("<line x1=\"248\" y1=\"165\" x2=\"248\" y2=\"234\" stroke=\"#27ae60\" stroke-width=\"0.8\" stroke-dasharray=\"4,2\"></line><line x1=\"244\" y1=\"165\" x2=\"252\" y2=\"165\" stroke=\"#27ae60\" stroke-width=\"1\"></line><line x1=\"244\" y1=\"234\" x2=\"252\" y2=\"234\" stroke=\"#27ae60\" stroke-width=\"1\"></line><line x1=\"182\" y1=\"165\" x2=\"248\" y2=\"165\" stroke=\"#27ae60\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><rect x=\"218\" y=\"186\" width=\"66\" height=\"24\" rx=\"3\" fill=\"#fff\" stroke=\"#b0d8b0\" stroke-width=\"0.5\"></rect>", 5)
const _hoisted_140 = {
  x: "251",
  y: "198",
  "text-anchor": "middle",
  class: "label-text label-green"
}
const _hoisted_141 = {
  key: 0,
  x: "251",
  y: "207",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_142 = ["fill"]
const _hoisted_143 = { key: 9 }
const _hoisted_144 = /*#__PURE__*/_createStaticVNode("<line x1=\"338\" y1=\"165\" x2=\"338\" y2=\"390\" stroke=\"#27ae60\" stroke-width=\"0.8\" stroke-dasharray=\"4,2\"></line><line x1=\"334\" y1=\"165\" x2=\"342\" y2=\"165\" stroke=\"#27ae60\" stroke-width=\"1\"></line><line x1=\"334\" y1=\"390\" x2=\"342\" y2=\"390\" stroke=\"#27ae60\" stroke-width=\"1\"></line><line x1=\"182\" y1=\"165\" x2=\"338\" y2=\"165\" stroke=\"#27ae60\" stroke-width=\"0.4\" stroke-dasharray=\"2,3\" opacity=\"0.3\"></line><rect x=\"314\" y=\"268\" width=\"50\" height=\"24\" rx=\"3\" fill=\"#fff\" stroke=\"#b0d8b0\" stroke-width=\"0.5\"></rect>", 5)
const _hoisted_149 = {
  x: "339",
  y: "280",
  "text-anchor": "middle",
  class: "label-text label-green"
}
const _hoisted_150 = {
  key: 0,
  x: "339",
  y: "289",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_151 = ["fill"]
const _hoisted_152 = { key: 10 }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("rect", {
  x: "110",
  y: "416",
  width: "80",
  height: "24",
  rx: "3",
  fill: "#fff",
  stroke: "#ddd",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_154 = {
  x: "150",
  y: "428",
  "text-anchor": "middle",
  class: "label-text"
}
const _hoisted_155 = {
  key: 0,
  x: "150",
  y: "437",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_156 = ["fill"]
const _hoisted_157 = { key: 11 }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("rect", {
  x: "112",
  y: "446",
  width: "76",
  height: "24",
  rx: "4",
  fill: "#f0f6ff",
  stroke: "#d6e4f0",
  "stroke-width": "0.5"
}, null, -1)
const _hoisted_159 = {
  x: "150",
  y: "458",
  "text-anchor": "middle",
  class: "label-text-lg"
}
const _hoisted_160 = {
  key: 0,
  x: "150",
  y: "467",
  "text-anchor": "middle",
  class: "label-avg"
}
const _hoisted_161 = ["fill"]
const _hoisted_162 = { class: "history-section" }
const _hoisted_163 = { class: "history-card" }
const _hoisted_164 = { class: "history-title" }
const _hoisted_165 = { class: "history-table-wrap" }
const _hoisted_166 = { class: "history-table" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "측정일"),
    /*#__PURE__*/_createElementVNode("th", null, "키"),
    /*#__PURE__*/_createElementVNode("th", null, "체중"),
    /*#__PURE__*/_createElementVNode("th", null, "어깨"),
    /*#__PURE__*/_createElementVNode("th", null, "가슴"),
    /*#__PURE__*/_createElementVNode("th", null, "허리"),
    /*#__PURE__*/_createElementVNode("th", null, "엉덩이"),
    /*#__PURE__*/_createElementVNode("th", null, "허벅지"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_168 = ["onClick"]
const _hoisted_169 = { class: "history-cards" }
const _hoisted_170 = { class: "card-header" }
const _hoisted_171 = { class: "card-date" }
const _hoisted_172 = ["onClick"]
const _hoisted_173 = { class: "card-body" }
const _hoisted_174 = { key: 0 }
const _hoisted_175 = { key: 1 }
const _hoisted_176 = { key: 2 }
const _hoisted_177 = { key: 3 }
const _hoisted_178 = { key: 4 }
const _hoisted_179 = { key: 5 }
const _hoisted_180 = { key: 6 }
const _hoisted_181 = { key: 7 }
const _hoisted_182 = {
  key: 1,
  class: "history-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active: !_ctx.useInch }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.useInch = false))
                }, "cm", 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active: _ctx.useInch }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useInch = true))
                }, "inch", 2)
              ]),
              _createElementVNode("label", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bodyForm.isPublic) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.bodyForm.isPublic]
                ]),
                _hoisted_11
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bodyForm.gender) = $event))
              }, _hoisted_18, 512), [
                [_vModelSelect, _ctx.bodyForm.gender]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", null, [
                _createTextVNode("키 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.height
                }, "?", 8, _hoisted_20)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.height, 'cm'),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.si('height', $event, 'cm'))),
                placeholder: "175.0",
                step: "0.1"
              }, null, 40, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", null, [
                _createTextVNode("체중 (kg) "),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.weight
                }, "?", 8, _hoisted_23)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.bodyForm.weight,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.si('weight', $event, 'kg'))),
                placeholder: "70.0",
                step: "0.1"
              }, null, 40, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", null, [
                _createTextVNode("어깨 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.shoulderWidth
                }, "?", 8, _hoisted_27)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.shoulderWidth, 'cm'),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.si('shoulderWidth', $event, 'cm'))),
                placeholder: "45.0",
                step: "0.1"
              }, null, 40, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", null, [
                _createTextVNode("가슴둘레 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.chest
                }, "?", 8, _hoisted_30)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.chest, 'cm'),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.si('chest', $event, 'cm'))),
                placeholder: "95.0",
                step: "0.1"
              }, null, 40, _hoisted_31)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", null, [
                _createTextVNode("허리둘레 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.waist
                }, "?", 8, _hoisted_33)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.waist, 'cm'),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.si('waist', $event, 'cm'))),
                placeholder: "80.0",
                step: "0.1"
              }, null, 40, _hoisted_34)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", null, [
                _createTextVNode("엉덩이둘레 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.hip
                }, "?", 8, _hoisted_37)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.hip, 'cm'),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.si('hip', $event, 'cm'))),
                placeholder: "97.0",
                step: "0.1"
              }, null, 40, _hoisted_38)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", null, [
                _createTextVNode("팔길이 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.armLength
                }, "?", 8, _hoisted_40)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.armLength, 'cm'),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.si('armLength', $event, 'cm'))),
                placeholder: "60.0",
                step: "0.1"
              }, null, 40, _hoisted_41)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", null, [
                _createTextVNode("허벅지둘레 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.thigh
                }, "?", 8, _hoisted_43)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.thigh, 'cm'),
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.si('thigh', $event, 'cm'))),
                placeholder: "55.0",
                step: "0.1"
              }, null, 40, _hoisted_44)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("label", null, [
                _createTextVNode("인심 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.legLength
                }, "?", 8, _hoisted_47)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.legLength, 'cm'),
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.si('legLength', $event, 'cm'))),
                placeholder: "78.0",
                step: "0.1"
              }, null, 40, _hoisted_48)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", null, [
                _createTextVNode("밑위길이 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.rise
                }, "?", 8, _hoisted_50)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.rise, 'cm'),
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.si('rise', $event, 'cm'))),
                placeholder: "26.5",
                step: "0.1"
              }, null, 40, _hoisted_51)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("label", null, [
                _createTextVNode("총장 (" + _toDisplayString(_ctx.ul('cm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.totalLength
                }, "?", 8, _hoisted_53)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.totalLength, 'cm'),
                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.si('totalLength', $event, 'cm'))),
                placeholder: "104.0",
                step: "0.1"
              }, null, 40, _hoisted_54)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("label", null, [
                _createTextVNode("발사이즈 (" + _toDisplayString(_ctx.ul('mm')) + ") ", 1),
                _createElementVNode("span", {
                  class: "help-icon",
                  "data-tooltip": _ctx.MEASURE_HELP.footSize
                }, "?", 8, _hoisted_57)
              ]),
              _createElementVNode("input", {
                type: "number",
                value: _ctx.iv(_ctx.bodyForm.footSize, 'mm'),
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.si('footSize', $event, 'mm'))),
                placeholder: "270",
                step: "1"
              }, null, 40, _hoisted_58)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveBody && _ctx.saveBody(...args)))
            }, "저장")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            (_openBlock(), _createElementBlock("svg", _hoisted_64, [
              _hoisted_65,
              (_ctx.bodyForm.height)
                ? (_openBlock(), _createElementBlock("g", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("text", _hoisted_72, _toDisplayString(_ctx.dv(_ctx.bodyForm.height, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_73, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.height, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.height, _ctx.avgData.height)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.height, _ctx.avgData.height, 'cm')), 9, _hoisted_74)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.shoulderWidth)
                ? (_openBlock(), _createElementBlock("g", _hoisted_75, [
                    _hoisted_76,
                    _hoisted_77,
                    _hoisted_78,
                    _hoisted_79,
                    _createElementVNode("text", _hoisted_80, "어깨 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.shoulderWidth, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_81, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.shoulderWidth, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.shoulderWidth, _ctx.avgData.shoulderWidth)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.shoulderWidth, _ctx.avgData.shoulderWidth, 'cm')), 9, _hoisted_82)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.chest)
                ? (_openBlock(), _createElementBlock("g", _hoisted_83, [
                    _hoisted_84,
                    _hoisted_85,
                    _hoisted_86,
                    _hoisted_87,
                    _createElementVNode("text", _hoisted_88, "가슴 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.chest, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_89, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.chest, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.chest, _ctx.avgData.chest)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.chest, _ctx.avgData.chest, 'cm')), 9, _hoisted_90)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.waist)
                ? (_openBlock(), _createElementBlock("g", _hoisted_91, [
                    _hoisted_92,
                    _hoisted_93,
                    _hoisted_94,
                    _hoisted_95,
                    _createElementVNode("text", _hoisted_96, "허리 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.waist, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_97, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.waist, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.waist, _ctx.avgData.waist)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.waist, _ctx.avgData.waist, 'cm')), 9, _hoisted_98)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.hip)
                ? (_openBlock(), _createElementBlock("g", _hoisted_99, [
                    _hoisted_100,
                    _hoisted_101,
                    _hoisted_102,
                    _hoisted_103,
                    _createElementVNode("text", _hoisted_104, "엉덩이 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.hip, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_105, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.hip, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.hip, _ctx.avgData.hip)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.hip, _ctx.avgData.hip, 'cm')), 9, _hoisted_106)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.armLength)
                ? (_openBlock(), _createElementBlock("g", _hoisted_107, [
                    _hoisted_108,
                    _createElementVNode("text", _hoisted_114, "팔 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.armLength, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_115, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.armLength, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.armLength, _ctx.avgData.armLength)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.armLength, _ctx.avgData.armLength, 'cm')), 9, _hoisted_116)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.thigh)
                ? (_openBlock(), _createElementBlock("g", _hoisted_117, [
                    _hoisted_118,
                    _hoisted_119,
                    _hoisted_120,
                    _hoisted_121,
                    _createElementVNode("text", _hoisted_122, "허벅지 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.thigh, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_123, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.thigh, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.thigh, _ctx.avgData.thigh)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.thigh, _ctx.avgData.thigh, 'cm')), 9, _hoisted_124)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.legLength)
                ? (_openBlock(), _createElementBlock("g", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("text", _hoisted_131, "인심 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.legLength, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_132, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.legLength, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.legLength, _ctx.avgData.legLength)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.legLength, _ctx.avgData.legLength, 'cm')), 9, _hoisted_133)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.rise)
                ? (_openBlock(), _createElementBlock("g", _hoisted_134, [
                    _hoisted_135,
                    _createElementVNode("text", _hoisted_140, "밑위 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.rise, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_141, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.rise, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.rise, _ctx.avgData.rise)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.rise, _ctx.avgData.rise, 'cm')), 9, _hoisted_142)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.totalLength)
                ? (_openBlock(), _createElementBlock("g", _hoisted_143, [
                    _hoisted_144,
                    _createElementVNode("text", _hoisted_149, "총장 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.totalLength, 'cm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_150, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.totalLength, 'cm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.totalLength, _ctx.avgData.totalLength)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.totalLength, _ctx.avgData.totalLength, 'cm')), 9, _hoisted_151)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.footSize)
                ? (_openBlock(), _createElementBlock("g", _hoisted_152, [
                    _hoisted_153,
                    _createElementVNode("text", _hoisted_154, "발 " + _toDisplayString(_ctx.dv(_ctx.bodyForm.footSize, 'mm')), 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_155, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.dvRaw(_ctx.avgData.footSize, 'mm')) + " ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.footSize, _ctx.avgData.footSize)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.footSize, _ctx.avgData.footSize, 'mm')), 9, _hoisted_156)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bodyForm.weight)
                ? (_openBlock(), _createElementBlock("g", _hoisted_157, [
                    _hoisted_158,
                    _createElementVNode("text", _hoisted_159, _toDisplayString(_ctx.bodyForm.weight) + "kg", 1),
                    (_ctx.bodyForm.gender)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_160, [
                          _createTextVNode(" 평균 " + _toDisplayString(_ctx.avgData.weight) + "kg ", 1),
                          _createElementVNode("tspan", {
                            fill: _ctx.diffFill(_ctx.bodyForm.weight, _ctx.avgData.weight)
                          }, _toDisplayString(_ctx.svgDiff(_ctx.bodyForm.weight, _ctx.avgData.weight, 'kg')), 9, _hoisted_161)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_162, [
      _createElementVNode("div", _hoisted_163, [
        _createElementVNode("div", _hoisted_164, "신체정보 히스토리 (" + _toDisplayString(_ctx.historyList.length) + "건)", 1),
        (_ctx.historyList.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("table", _hoisted_166, [
                  _hoisted_167,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyList, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.fmtDate(item.measuredDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.height ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.weight ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.shoulderWidth ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.chest ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.waist ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.hip ?? '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.thigh ?? '-'), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "btn-delete",
                            onClick: ($event: any) => (_ctx.deleteHistory(item.id))
                          }, "삭제", 8, _hoisted_168)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "history-card-item",
                    key: 'm-' + item.id
                  }, [
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.fmtDate(item.measuredDate)), 1),
                      _createElementVNode("button", {
                        class: "btn-delete",
                        onClick: ($event: any) => (_ctx.deleteHistory(item.id))
                      }, "삭제", 8, _hoisted_172)
                    ]),
                    _createElementVNode("div", _hoisted_173, [
                      (item.height)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_174, "키 " + _toDisplayString(item.height), 1))
                        : _createCommentVNode("", true),
                      (item.weight)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_175, "체중 " + _toDisplayString(item.weight), 1))
                        : _createCommentVNode("", true),
                      (item.shoulderWidth)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_176, "어깨 " + _toDisplayString(item.shoulderWidth), 1))
                        : _createCommentVNode("", true),
                      (item.chest)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_177, "가슴 " + _toDisplayString(item.chest), 1))
                        : _createCommentVNode("", true),
                      (item.waist)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_178, "허리 " + _toDisplayString(item.waist), 1))
                        : _createCommentVNode("", true),
                      (item.hip)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_179, "엉덩이 " + _toDisplayString(item.hip), 1))
                        : _createCommentVNode("", true),
                      (item.thigh)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_180, "허벅지 " + _toDisplayString(item.thigh), 1))
                        : _createCommentVNode("", true),
                      (item.footSize)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_181, "발 " + _toDisplayString(item.footSize) + "mm", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_182, " 신체정보를 저장하면 히스토리가 쌓입니다. "))
      ])
    ])
  ]))
}